import React, { useEffect, useRef, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import "./adZoneResponsive.css";

// for modal design
const IOSSwitch = Index.styled((props) => (
  <Index.Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  width: 34,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 3,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#3c0000",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 14,
    height: 14,
    boxShadow: "none",
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
};

export default function AdZoneDetails() {
  const { adminDetails } = PagesIndex.useSelector(
    (state) => state.AdminReducer
  );
  const formRef = useRef();
  const [data, setData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [deleteButtonSpinner, setDeleteButtonSpinner] = useState(false);
  const [id, setId] = useState("");
  const [selectedZoneData, setSelectedZoneData] = useState();
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [buttonSpinner, setButtonSpinner] = useState(false);

  const initialValues = {
    state: id ? selectedZoneData?.state?._id : "",
    zoneName: id ? selectedZoneData?.name : "",
    image: "",
    imageUrl: id ? selectedZoneData?.image : "",
  };
  const [addOrEdit, setAddOrEdit] = useState("Add");
  const [filteredData, setFilteredData] = useState([]);
  // add user modal
  const [open, setOpen] = useState(false);
  // delete modal
  const [openDelete, setOpenDelete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [statusButtonSpinner, setStatusButtonSpinner] = useState(false);
  const [activityLog, setActivityLog] = useState([]);
  const [activityLoading, setActivityLoading] = useState(true);

  const [openLogModal, setOpenLogModal] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const handleCloseLogModal = () => setOpenLogModal(false);

  const handleOpenLogModal = (id) => {
    setOpenLogModal(true);
    setActivityLoading(true);
    PagesIndex.apiGetHandler(
      PagesIndex.Api.GET_AD_ZONE_ACTIVITY_LOG + "/" + id
    ).then((res) => {
      setActivityLoading(false);
      if (res.status === 200) {
        setActivityLog(res.data?.activityLog);
      }
    });
  };

  const handleGetState = () => {
    PagesIndex.apiGetHandler(PagesIndex.Api.GET_STATE).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        const activeState = res?.data?.filter((state) => state?.isActive);
        setStateData(activeState);
      }
    });
  };

  useEffect(() => {
    setLoading(true);
    handleGetZone();
    handleGetState();
  }, []);
  const handleOpen = (op, id, data) => {
    setOpen(true);
    setAddOrEdit(op);
    setId(id);
    setSelectedZoneData(data);
  };
  const handleClose = () => {
    formRef.current.resetForm();
    setOpen(false);
  };
  const handleOpenDelete = (id) => {
    setOpenDelete(true);
    setId(id);
  };
  const handleCloseDelete = () => {
    setId("");
    setOpenDelete(false);
  };
  const handleGetZone = () => {
    PagesIndex.apiGetHandler(PagesIndex.Api.GET_AD_ZONEMASTER).then((res) => {
      if (res.status === 200) {
        let data = res?.data?.sort((a, b) =>
          a?.name?.localeCompare(b?.name));
        setData(data);
        setFilteredData(data);
      }
    });
  };
  const handleAddEditZone = (values) => {
    setButtonSpinner(true)
    const formdata = new FormData();
    if (id) {
      formdata.append("id", id);
    }
    formdata.append("state", values?.state);
    formdata.append("name", values?.zoneName);
    if (values.image) {
      formdata.append("profile", values?.image);
    }

    PagesIndex.apiPostHandler(PagesIndex.Api.ADD_EDIT_AD_ZONEMASTER, formdata)
      .then((res) => {
        setButtonSpinner(false)
        if (res.status === 201 || res.status === 200) {
          handleClose();
          handleGetZone();
          setSearchValue("");
          PagesIndex.toasterSuccess(res?.message);
        } else {
          PagesIndex.toasterError(res?.message);
        }
      })
      .catch((err) => {
        PagesIndex.toasterError(err.response.message);
      });
  };

  const handleDeleteZone = () => {
    setDeleteButtonSpinner(true)
    const urlEncoded = new URLSearchParams();
    urlEncoded.append("id", id);
    PagesIndex.apiPostHandler(
      PagesIndex.Api.DELETE_AD_ZONEMASTER,
      urlEncoded
    ).then((res) => {
      setDeleteButtonSpinner(false)
      if (res.status === 200) {
        handleCloseDelete();
        handleGetZone();
        PagesIndex.toasterSuccess(res?.message);
      } else {
        PagesIndex.toasterError(res?.message);
      }
    });
  };
  const requestSearch = (e) => {
    setSearchValue(e.target.value);
    let result = data.filter((data) => {
      let name = data?.name
        ?.toLowerCase()
        .includes(e?.target?.value?.trim()?.toLowerCase());
      let state = data?.state?.stateName
        ?.toLowerCase()
        .includes(e?.target?.value?.trim()?.toLowerCase());
      return name || state;
    });

    setCurrentPage(1);
    setFilteredData(result);
  };
  const handleOpenStatusModal = (id) => {
    setId(id);
    setOpenStatusModal(true);
  };
  const handleCloseStatusModal = () => {
    setId("");
    setOpenStatusModal(false);
  };
  const handleStatus = () => {
    setStatusButtonSpinner(true)
    const urlEncoded = new URLSearchParams();
    urlEncoded.append("id", id);
    PagesIndex.apiPostHandler(PagesIndex.Api.ISACTIVE_AD_ZONE, urlEncoded).then(
      (res) => {
        setStatusButtonSpinner(false)
        if (res.status === 200) {
          handleGetZone();
          handleCloseStatusModal();
          PagesIndex.toasterSuccess(res?.message);
        } else {
          PagesIndex.toasterError(res?.message);
        }
      }
    );
  };

  const renderTableRows = () => {
    return filteredData
      ?.slice((currentPage - 1) * 10, (currentPage - 1) * 10 + 10)
      ?.map((data) => {
        return (
          <Index.TableRow
            sx={{
              "&:last-child td, &:last-child th": {
                border: 0,
              },
            }}
            key={data?._id}
          >
            <Index.TableCell
              component="td"
              variant="td"
              scope="row"
              className="table-td"
            >
              <Index.Box className="admin-table-data-flex">
                <img
                  src={
                    data?.image
                      ? process.env.REACT_APP_IMAGE_ENDPOINT + data?.image
                      : PagesIndex.Svg.noimgfound
                  }
                  className="admin-table-data-img"
                  alt="Zone"
                ></img>
              </Index.Box>
            </Index.TableCell>

            <Index.TableCell component="td" variant="td" className="table-td">
              <Index.Typography className="admin-table-data-text">
                {" "}
                {data?.name}
              </Index.Typography>
            </Index.TableCell>
            <Index.TableCell component="td" variant="td" className="table-td">
              <Index.Typography className="admin-table-data-text">
                {" "}
                {data?.state?.stateName}
              </Index.Typography>
            </Index.TableCell>
            <Index.TableCell
              component="td"
              variant="td"
              className="table-td"
              align="right"
            >
              <Index.Typography className="admin-table-data-text">
                {data?.createdBy?.name || "-"}
              </Index.Typography>
            </Index.TableCell>
            <Index.TableCell
              component="td"
              variant="td"
              className="table-td"
              align="right"
            >
              <Index.Typography className="admin-table-data-text">
                {data?.updatedBy?.name || "-"}
              </Index.Typography>
            </Index.TableCell>
            {(adminDetails?.roleId?.permissions?.includes("client_zone_edit") ||
              adminDetails?.roleId?.permissions?.includes("client_zone_delete")) && (
                <Index.TableCell
                  component="td"
                  variant="td"
                  align="right"
                  className="table-td"
                >
                  <Index.Tooltip
                    title={data?.isActive ? "Active" : "Deactive"}
                    arrow
                    placement="bottom"
                    className="admin-tooltip"
                  >
                    <Index.Box className="admin-switch-main">
                      <Index.FormControlLabel
                        control={<IOSSwitch sx={{ m: 1 }} />}
                        className="admin-switch-lable"
                        checked={data?.isActive}
                        onChange={() => {
                          handleOpenStatusModal(data?._id);
                        }}
                      />
                    </Index.Box>
                  </Index.Tooltip>
                </Index.TableCell>
              )}

            {(adminDetails?.roleId?.permissions?.includes("client_zone_edit") ||
              adminDetails?.roleId?.permissions?.includes("client_zone_delete") ||
              adminDetails?.roleId?.permissions?.includes("client_zone_log")) && (
                <Index.TableCell
                  component="td"
                  variant="td"
                  align="right"
                  className="table-td"
                >
                  <Index.Box className="admin-table-data-btn-flex ">
                    {adminDetails?.roleId?.permissions?.includes("client_zone_edit") && (
                      <Index.Tooltip
                        title="Edit"
                        arrow
                        placement="bottom"
                        className="admin-tooltip"
                      >
                        <Index.Button
                          className="admin-table-data-btn"
                          onClick={() => {
                            handleOpen("Edit", data?._id, data);
                          }}
                        >
                          <img
                            src={PagesIndex.Svg.blueedit}
                            className="admin-icon"
                            alt="Edit"
                          ></img>
                        </Index.Button>
                      </Index.Tooltip>
                    )}

                    {adminDetails?.roleId?.permissions?.includes("client_zone_log") && (
                      <Index.Tooltip
                        title="Log"
                        arrow
                        placement="bottom"
                        className="admin-tooltip"
                      >
                        <Index.Button
                          className="admin-table-data-btn"
                          onClick={() => handleOpenLogModal(data?._id)}
                        >
                          <img
                            src={PagesIndex.Svg.logicon}
                            className="admin-icon"
                            alt="Log"
                          ></img>
                        </Index.Button>
                      </Index.Tooltip>
                    )}

                    {adminDetails?.roleId?.permissions?.includes(
                      "client_zone_delete"
                    ) && (
                        <Index.Tooltip
                          title="Delete"
                          arrow
                          placement="bottom"
                          className="admin-tooltip"
                        >
                          <Index.Button
                            className="admin-table-data-btn"
                            onClick={() => handleOpenDelete(data?._id)}
                          >
                            <img
                              src={PagesIndex.Svg.trash}
                              className="admin-icon"
                              alt="Delete"
                            ></img>
                          </Index.Button>
                        </Index.Tooltip>
                      )}
                  </Index.Box>
                </Index.TableCell>
              )}
          </Index.TableRow>
        );
      });
  };

  const renderContent = () => {
    if (filteredData?.length) {
      return renderTableRows();
    } else {
      return <PagesIndex.DataNotFound />;
    }
  };

  const renderActivityTableRows = () => {
    return activityLog
      .slice()
      .reverse()
      .map((data) => {
        let updatedInfo = "";

        if (
          data?.updatedState?.stateName !== data?.previousState?.stateName ||
          data?.previousZoneName !== data?.updatedZoneName ||
          data?.previousStatus !== data?.updatedStatus
        ) {
          if (data?.updatedBy?.name) {
            updatedInfo = `${data?.updatedBy?.name}-${data?.dateTime
              ? PagesIndex.moment(data?.dateTime).format(
                "DD/MM/YYYY HH:mm:ss"
              )
              : "-"
              }`;
          } else {
            updatedInfo = "-";
          }
        }
        return (
          <Index.TableRow
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            key={data?._id}
          >
            {updatedInfo !== "" && (
              <>
                <Index.TableCell
                  component="td"
                  variant="td"
                  scope="row"
                  className="table-td"
                >
                  <Index.Typography className="admin-table-data-text">
                    <Index.Tooltip
                      title={`${data?.previousZoneName !== data?.updatedZoneName
                        ? `${data?.updatedBy?.name} has updated Zone Name from ${data?.previousZoneName
                        } to ${data?.updatedZoneName + " "}`
                        : ""
                        }`}
                      arrow
                      placement="top"
                      className="admin-tooltip"
                    >
                      {data?.previousZoneName !== data?.updatedZoneName && (
                        <span>
                          <span className="span-bold">
                            {data?.updatedBy?.name}
                          </span>{" "}
                          has updated Zone Name from{" "}
                          <span className="span-bold">
                            {data?.previousZoneName}
                          </span>{" "}
                          to{" "}
                          <span className="span-bold">
                            {data?.updatedZoneName + " "}
                          </span>
                        </span>
                      )}
                    </Index.Tooltip>
                  </Index.Typography>

                  <Index.Typography className="admin-table-data-text">
                    <Index.Tooltip
                      title={`${data?.updatedState?.stateName !==
                        data?.previousState?.stateName
                        ? `${data?.updatedBy?.name} has updated State Name from ${data?.previousState?.stateName
                        } to ${data?.updatedState?.stateName + " "}`
                        : ""
                        }`}
                      arrow
                      placement="top"
                      className="admin-tooltip"
                    >
                      {data?.updatedState?.stateName !==
                        data?.previousState?.stateName && (
                          <span>
                            <span className="span-bold">
                              {data?.updatedBy?.name}
                            </span>{" "}
                            has updated State Name from{" "}
                            <span className="span-bold">
                              {data?.previousState?.stateName}
                            </span>{" "}
                            to{" "}
                            <span className="span-bold">
                              {data?.updatedState?.stateName + " "}
                            </span>
                          </span>
                        )}
                    </Index.Tooltip>
                  </Index.Typography>

                  <Index.Typography className="admin-table-data-text">
                    <Index.Tooltip
                      title={`${data?.previousStatus !== data?.updatedStatus
                        ? `${data?.updatedBy?.name} Status  has been updated from ${!data?.updatedStatus ? "Active" : "Deactive"
                        } to ${data?.updatedStatus ? "Active" : "Deactive"} `
                        : ""
                        }`}
                      arrow
                      placement="top"
                      className="admin-tooltip"
                    >
                      {data?.previousStatus !== data?.updatedStatus && (
                        <span>
                          <span className="span-bold">
                            {data?.updatedBy?.name}
                          </span>{" "} Status  has been updated from{" "}
                          <span className="span-bold">
                            {!data?.updatedStatus ? "Active" : "Deactive"}
                          </span>{" "}
                          to&nbsp;
                          <span className="span-bold">
                            {data?.updatedStatus ? "Active" : "Deactive"}
                          </span>
                        </span>
                      )}
                    </Index.Tooltip>
                  </Index.Typography>

                  <Index.Typography className="admin-table-data-text">
                    <Index.Tooltip
                      title={`${data?.image ? "Image is Updated" : ""}`}
                      arrow
                      placement="top"
                      className="admin-tooltip"
                    >
                      <span>{data?.image && `Image is Updated`}</span>
                    </Index.Tooltip>
                  </Index.Typography>
                </Index.TableCell>

                <Index.TableCell
                  component="td"
                  variant="td"
                  className="table-td"
                >
                  {updatedInfo}
                </Index.TableCell>
              </>
            )}
          </Index.TableRow>
        );
      });
  };

  const renderActivityLogContent = () => {
    return (
      <>
        {!activityLoading &&
          activityLog?.length > 0 &&
          renderActivityTableRows()}
        {!activityLoading && (!activityLog || activityLog.length === 0) && (
          <PagesIndex.DataNotFound />
        )}
      </>
    );
  };

  // for img
  const renderImage = (values) => {
    const isUploadImg = values?.imageUrl || values.image;
    const isImageBlob = values.image instanceof Blob;
    const imageUrl = values?.imageUrl
      ? `${process.env.REACT_APP_IMAGE_ENDPOINT}${values?.imageUrl}`
      : null;
    let src;

    if (isImageBlob) {
      src = URL.createObjectURL(values.image);
    } else if (isUploadImg) {
      src = imageUrl;
    } else {
      src = PagesIndex.Svg.fileupload;
    }

    return (
      <img
        className={isUploadImg ? "upload-img" : "upload-profile-img"}
        src={src}
        alt="zone"
      />
    );
  };
  const ScrollIntoView = () => {
    // Scroll to the first error when errors change
    const { errors, isSubmitting } = PagesIndex.useFormikContext(); // Extracting errors from the Formik context
    useEffect(() => {
      if (errors && Object.keys(errors).length > 0) {
        const firstErrorField = Object.keys(errors)[0];
        let scrollDiv = document.getElementById("scrollDiv");
        const firstErrorElement = document.querySelector(
          `[id="${firstErrorField}"]`
        );
        if (firstErrorElement) {
          scrollDiv.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          firstErrorElement.focus();
        }
      }
    }, [isSubmitting]);
  };
  return (
    <>
      <Index.Box className="admin-dashboard-content admin-user-list-content">
        <Index.Box className="admin-user-list-flex admin-page-title-main">
          <Index.Typography
            className="admin-page-title admin-user-list-page-title"
            component="h2"
            variant="h2"
          >
            Zone List
          </Index.Typography>
          <Index.Box className="admin-userlist-btn-flex">
            <Index.Box className="admin-search-main">
              <Index.Box className="admin-search-box">
                <Index.Box className="admin-form-group">
                  <Index.TextField
                    fullWidth
                    id="fullWidth"
                    className="admin-form-control"
                    placeholder="Search"
                    value={searchValue}
                    onChange={requestSearch}
                  />
                  <img
                    src={PagesIndex.Svg.search}
                    className="admin-search-grey-img admin-icon"
                    alt="search"
                  ></img>
                </Index.Box>
              </Index.Box>
            </Index.Box>
            {adminDetails?.roleId?.permissions?.includes("client_zone_add") && (
              <Index.Box className="admin-userlist-inner-btn-flex">
                <Index.Box className="admin-adduser-btn-main btn-main-primary">
                  <Index.Button
                    className="admin-adduser-btn btn-primary"
                    onClick={() => {
                      setId("");
                      handleOpen("Add");
                    }}
                  >
                    <img
                      src={PagesIndex.Svg.plus}
                      className="admin-plus-icon"
                      alt="plus"
                    />
                    <span>Add Zone</span>
                  </Index.Button>
                </Index.Box>
              </Index.Box>
            )}
          </Index.Box>
        </Index.Box>

        <Index.Box className="common-card">
          <Index.Box
            className={`admin-ad-zone-table-main ${loading ? "" : "page-table-main"
              }`}
          >
            <Index.TableContainer
              component={Index.Paper}
              className="table-container"
            >
              {loading ? (
                <PagesIndex.Loader />
              ) : (
                <Index.Table aria-label="simple table" className="table">
                  <Index.TableHead className="table-head">
                    <Index.TableRow className="table-row">
                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="10%"
                      >
                        Thumbnail
                      </Index.TableCell>

                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="10%"
                      >
                        Zone Name
                      </Index.TableCell>
                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="20%"
                      >
                        State Name
                      </Index.TableCell>
                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="12%"
                        align="right"
                      >
                        Created By
                      </Index.TableCell>
                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="12%"
                        align="right"
                      >
                        Updated By
                      </Index.TableCell>

                      {(adminDetails?.roleId?.permissions?.includes(
                        "client_zone_edit"
                      ) ||
                        adminDetails?.roleId?.permissions?.includes(
                          "client_zone_delete"
                        )) && (
                          <Index.TableCell
                            component="th"
                            variant="th"
                            className="table-th"
                            width="10%"
                            align="right"
                          >
                            Status
                          </Index.TableCell>
                        )}

                      {(adminDetails?.roleId?.permissions?.includes(
                        "client_zone_edit"
                      ) ||
                        adminDetails?.roleId?.permissions?.includes(
                          "client_zone_delete"
                        ) ||
                        adminDetails?.roleId?.permissions?.includes(
                          "client_zone_log"
                        )) && (
                          <Index.TableCell
                            component="th"
                            variant="th"
                            className="table-th"
                            width="10%"
                            align="right"
                          >
                            Action
                          </Index.TableCell>
                        )}
                    </Index.TableRow>
                  </Index.TableHead>
                  <Index.TableBody className="table-body">
                    {renderContent()}
                  </Index.TableBody>
                </Index.Table>
              )}
            </Index.TableContainer>
          </Index.Box>
          <Index.Box className="admin-pagination-main">
            {filteredData?.length ? (
              <Index.Pagination
                page={currentPage}
                count={Math.ceil(filteredData?.length / 10)}
                onChange={(event, newPage) => setCurrentPage(newPage)}
                variant="outlined"
                shape="rounded"
                className="admin-pagination"
              />
            ) : (
              ""
            )}
          </Index.Box>
        </Index.Box>
      </Index.Box>

      <Index.Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="admin-modal"
      >
        <PagesIndex.Formik
          enableReinitialize
          onSubmit={handleAddEditZone}
          initialValues={initialValues}
          validationSchema={
            id ? PagesIndex.zoneEditSchema : PagesIndex.zoneAddSchema
          }
          innerRef={formRef}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            setFieldValue,
            setTouched,
          }) => (
            <form onSubmit={handleSubmit}>
              <Index.Box
                sx={style}
                className="admin-add-user-modal-inner-main admin-modal-inner"
              >
                <Index.Box className="admin-modal-header">
                  <Index.Typography
                    id="modal-modal-title"
                    className="admin-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    {addOrEdit} Zone
                  </Index.Typography>
                  {/* <Index.Box className="modal-close-btn" onClick={handleClose}>
                    <img
                      src={PagesIndex.Svg.closeblack}
                      className="admin-modal-close-icon"
                      alt="Close"
                    />
                  </Index.Box> */}
                </Index.Box>
                <Index.Box
                  component={"form"}
                  noValidate="novalidate"
                  onSubmit={handleSubmit}
                  className="admin-modal-hgt-scroll cus-scrollbar"
                  id="scrollDiv"
                >
                  {/* <ScrollIntoView /> */}
                  <Index.Box className="admin-input-box admin-modal-input-box">
                    <Index.FormHelperText className="admin-form-lable">
                      State<span className="astrick-sing">*</span>
                    </Index.FormHelperText>
                    <Index.Box className="admin-form-group">
                      <Index.Autocomplete
                        className="admin-auto-complete-control"
                        options={stateData || []}
                        id="state"
                        closeText={""}
                        openText={""}
                        clearText={""}
                        value={
                          values?.state
                            ? stateData?.find((o) => o._id === values?.state)
                            : values?.state || null
                        }
                        onChange={(e, value) => {
                          setFieldValue("state", value?._id);
                        }}
                        getOptionLabel={(option) => option?.stateName}
                        renderOption={(props, item) => (
                          <li {...props} key={item?._id}>
                            {item?.stateName}
                          </li>
                        )}
                        renderInput={(params) => (
                          <Index.TextField
                            fullWidth
                            className="admin-form-control"
                            name="state"
                            {...params}
                            size="small"
                            variant="outlined"
                            placeholder="Select State"
                          />
                        )}
                      />
                      {errors.state && (
                        <PagesIndex.FormHelperText className="admin-error-text">
                          {errors.state}
                        </PagesIndex.FormHelperText>
                      )}
                    </Index.Box>
                  </Index.Box>
                  <Index.Box className="admin-input-box admin-modal-input-box">
                    <Index.FormHelperText className="admin-form-lable">
                      Zone Name<span className="astrick-sing">*</span>
                    </Index.FormHelperText>
                    <Index.Box className="admin-form-group">
                      <Index.TextField
                        name="zoneName"
                        fullWidth
                        id="zoneName"
                        className="admin-form-control"
                        placeholder="Enter Zone Name"
                        onChange={handleChange}
                        value={values?.zoneName}
                        inputProps={{ maxLength: 25 }}
                      // error={errors.zoneName && touched.zoneName}
                      />
                      {touched.zoneName && errors.zoneName && (
                        <PagesIndex.FormHelperText className="admin-error-text">
                          {errors.zoneName}
                        </PagesIndex.FormHelperText>
                      )}
                    </Index.Box>
                  </Index.Box>
                  <Index.Box className="admin-input-box admin-modal-input-box">
                    <Index.FormHelperText className="admin-form-lable">
                      Thumbnail<span className="astrick-sing">*</span>
                      <span className="option-condition-text">
                        (Image must be 135px(Width) * 100px(Height))
                      </span>
                    </Index.FormHelperText>
                    <Index.Box className="file-upload-main thumbnail-box">
                      <Index.Button
                        variant="contained"
                        component="label"
                        className="file-upload-button"
                      >
                        {renderImage(values)}

                        <input
                          hidden
                          accept="image/*"
                          id="image"
                          name="image"
                          type="file"
                          onChange={(e) => {
                            if (e.target.files?.length !== 0) {
                              setFieldValue("image", e.target.files[0]);
                            }
                          }}
                        />
                      </Index.Button>
                      {touched.image && errors.image && (
                        <PagesIndex.FormHelperText className="admin-error-text">
                          {errors.image}
                        </PagesIndex.FormHelperText>
                      )}
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
                <Index.Box className="modal-footer">
                  <Index.Box className="admin-modal-user-btn-flex">
                    <Index.Box className="admin-discard-btn-main border-btn-main">
                      <Index.Button
                        className="admin-discard-user-btn border-btn"
                        onClick={() => handleClose()}
                        disabled={buttonSpinner}
                      >
                        Discard
                      </Index.Button>
                    </Index.Box>
                    <Index.Box className="admin-save-btn-main btn-main-primary">
                      <Index.Button
                        className={`${id ? "update-btn" : "save-btn"} admin-save-user-btn btn-primary`}
                        type="submit"
                        disabled={buttonSpinner}
                      >
                        {buttonSpinner ? <PagesIndex.Spinner /> :
                          (<>
                            <img
                              src={PagesIndex.Svg.save}
                              className="admin-user-save-icon"
                              alt="Save"
                            />
                            <span>{id ? "Update" : "Add"}</span>
                          </>)
                        }
                      </Index.Button>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </form>
          )}
        </PagesIndex.Formik>
      </Index.Modal>

      <Index.Modal
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="admin-modal"
      >
        <Index.Box
          sx={style}
          className="admin-delete-modal-inner-main admin-modal-inner"
        >
          <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
            <Index.Box className="admin-modal-circle-main">
              <img
                src={PagesIndex.Svg.closecircle}
                className="admin-user-circle-img"
                alt="Close"
              />
            </Index.Box>
            <Index.Typography
              className="admin-delete-modal-title"
              component="h2"
              variant="h2"
            >
              Are you sure?
            </Index.Typography>
            <Index.Typography
              className="admin-delete-modal-para admin-common-para"
              component="p"
              variant="p"
            >
              Do you really want to delete this zone? This process cannot be
              undone.
            </Index.Typography>
            <Index.Box className="admin-delete-modal-btn-flex border-btn-main btn-main">
              <Index.Button
                className="admin-modal-cancel-btn border-btn"
                onClick={handleCloseDelete}
                disabled={deleteButtonSpinner}
              >
                Cancel
              </Index.Button>
              <Index.Button
                className="delete-user admin-modal-delete-btn btn"
                onClick={handleDeleteZone}
                disabled={deleteButtonSpinner}
              >
                {deleteButtonSpinner ? <PagesIndex.Spinner /> : <span>Delete</span>
                }
              </Index.Button>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Modal>

      <Index.Modal
        open={openLogModal}
        onClose={handleCloseLogModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="admin-modal"
      >
        <Index.Box
          sx={style}
          className="admin-log-modal-inner-main admin-modal-inner"
        >
          <Index.Box className="admin-modal-header">
            <Index.Typography
              id="modal-modal-title"
              className="admin-modal-title"
              variant="h6"
              component="h2"
            >
              {" "}
              Activity Log
            </Index.Typography>
            <Index.Button
              className="modal-close-btn"
              onClick={handleCloseLogModal}
            >
              <img
                src={PagesIndex.Svg.closeblack}
                className="admin-modal-close-icon"
                alt="Close"
              />
            </Index.Button>
          </Index.Box>
          <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
            <Index.Box className="common-card">
              <Index.Box className="page-table-main ad-zone-activity-table-main">
                <Index.TableContainer
                  component={Index.Paper}
                  className="table-container"
                >
                  {activityLoading ? (
                    <PagesIndex.Loader />
                  ) : (
                    <Index.Table aria-label="simple table" className="table">
                      <Index.TableHead className="table-head">
                        <Index.TableRow className="table-row">
                          <Index.TableCell
                            component="th"
                            variant="th"
                            className="table-th"
                            width="70%"
                          >
                            Activity Log
                          </Index.TableCell>
                          <Index.TableCell
                            component="th"
                            variant="th"
                            className="table-th"
                            width="30%"
                          >
                            Updated Date & Time
                          </Index.TableCell>
                        </Index.TableRow>
                      </Index.TableHead>
                      <Index.TableBody className="table-body">
                        {renderActivityLogContent()}
                      </Index.TableBody>
                    </Index.Table>
                  )}
                </Index.TableContainer>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Modal>
      <PagesIndex.ChangeStatusModal
        data={"zone"}
        statusButtonSpinner={statusButtonSpinner}
        openStatusModal={openStatusModal}
        handleCloseStatusModal={handleCloseStatusModal}
        handleChangeStatus={handleStatus}
      />
    </>
  );
}
